import { AutogenModelOtherChargeHist, AutogenRowOtherChargeHist } from "./autogen/AutogenModelOtherChargeHist";

export class ModelOtherChargeHist extends AutogenModelOtherChargeHist<RowOtherChargeHist> {
	constructor() {
		super(RowOtherChargeHist);
	}
}

export class RowOtherChargeHist extends AutogenRowOtherChargeHist {
}